<template>
	<div class="col-md-12 col-lg-12 mb-3">
		{{anios}}
		{{anioActual}}
		<b-overlay :show="isOverlay" rounded="sm" spinner-variant="primary" class="h-100">
			<div class="card card-grafica" style="max-height:450px;overflow-y:auto">
				<div class="card-body">
					<div class="filtro-grafic" id="grafica_002" v-if="isVisible">
						<div class="row justify-content-start">
							<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <form class="form-inline">
                                    <label class="title-grafic side-l mr-3">Propuestas</label>
									<label for="">Año</label>
									<select @change="GetDashboard" v-model="Anio" class="ml-2 form-control" id="">
										<option value="">Todos</option>
										<option v-for="(item,index) in pListaAnios" :key="index" :value="item">{{item}}</option>
									</select>

									<label class="ml-3">Mes</label>
									<select @change="GetDashboard()" v-model="Mes" class="form-control form-control-sm">
										<option value="">Acumulado</option>
										<option value="1">Enero</option>
										<option value="2">Febrero</option>
										<option value="3">Marzo</option>
										<option value="4">Abril</option>
										<option value="5">Mayo</option>
										<option value="6">Junio</option>
										<option value="7">Julio</option>
										<option value="8">Agosto</option>
										<option value="9">Septiembre</option>
										<option value="10">Octubre</option>
										<option value="11">Noviembre</option>
										<option value="12">Diciembre</option>
									</select>

									<label for="" class="ml-3">Tipo de Servicio</label>
									<select @change="GetDashboard" v-model="IdConfigS" class="ml-2 form-control" id="">
										<option value="">Todos</option>
										<option value="1">Mantenimiento</option>
										<option value="2">Servicio</option>
										<option value="3">Proyecto</option>
									</select>
                                </form>
                                <button type="button" class="btn close abs_01" @click="ocultarfiltro()"><i class="fal fa-times"></i></button>
                            </div>
						</div>
					</div>
					<div class="row">
						<div class="col-10 col-sm-10 col-md-8 col-lg-8">
							<h6 class="title-grafic side-l">Propuestas</h6>
						</div>
						<div class="col-2 col-sm-2 col-md-4 col-lg-4 text-right">
							<button	type="button" class="btn-fil-002" title="Filtros" @click="mostrarfiltro()">
								<i class="fas fa-filter"></i>
							</button>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<hr />
						</div>
					</div>
					<div class="row">
						<div class="table-responsive px-4">
							<table class="table-dashboard-despacho">
								<thead>
                                    <tr>
                                        <th class="text-center" style="font-size:19px;"></th>
                                        <th class="text-center" style="font-size:19px;">Activas</th>
                                        <th class="text-center" style="font-size:19px;">Activas</th>
                                        <th class="text-center" style="font-size:19px;">Perdidas</th>
                                        <th class="text-center" style="font-size:19px;">Perdidas</th>
                                        <th class="text-center" style="font-size:19px;">Ganadas</th>
                                        <th class="text-center" style="font-size:19px;">Ganadas</th>
										<th class="text-center" style="font-size:19px;">Vencidas</th>
                                        <th class="text-center" style="font-size:19px;">Vencidas</th>
                                    </tr>
                                </thead>
								<tbody>
									<tr v-for="(item,index) in ListaDashboard" :key="index">
										<td style="width:20%" class="pb-4 pl-4"><h2 :class="item.RegEstatus=='B' ? 'text-danger' : ''" style="font-size:23px;">{{ item.Nombre }}</h2></td>
										<td style="width:10%" class="pb-4 text-center"><h2 style="font-size:30px;color:#1B17BB">{{ item.PropuestasActivas }}</h2></td>
                                        <td style="width:10%" class="pb-4"><h2 class="text-center" style="font-size:30px;color:#1B17BB">$ {{ item.MontoActivas==null ? 0 : formateoMillon(parseInt(item.MontoActivas)) }}</h2></td>
										<td style="width:10%" class="pb-4 text-center"><h2 style="font-size:30px;" class="text-info">{{ item.PropuestasPerdidas }}</h2></td>
                                        <td style="width:10%" class="pb-4"><h2 class="text-center text-info" style="font-size:30px;">$ {{ item.MontoPerdidas==null ? 0 : formateoMillon(parseInt(item.MontoPerdidas)) }}</h2></td>
										<td style="width:10%" class="pb-4 text-center"><h2 class="" style="color:#1B17BB;font-size:30px;">{{ item.PropuestasGanadas }}</h2></td>
                                        <td style="width:11%" class="pb-4"><h2 class="text-center " style="color:#1B17BB;font-size:30px;">$ {{ item.MontoGanadas==null ? 0 : formateoMillon(parseInt(item.MontoGanadas)) }}</h2></td>
										<td style="width:10%" class="pb-4 text-center"><h2 class="" style="color:#1B17BB;font-size:30px;">{{ item.PropuestasVencidas }}</h2></td>
                                        <td style="width:13%" class="pb-4"><h2 class="text-center " style="color:#1B17BB;font-size:30px;">$ {{ item.MontoVencidas==null ? 0 : formateoMillon(parseInt(item.MontoVencidas)) }}</h2></td>
                                        <!-- <td class="tw-1"><h2 :class="parseInt(item.HorasTiposServicio[5].Horas)==0 ? 'text-center texto-claro' : 'text-center text-info'" style="font-size:39px;">{{ parseInt(item.HorasTiposServicio[5].Horas) }}</h2></td> -->
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</b-overlay>
	</div>
</template>

<script>
export default {
	name:"Vendedores",
	props:['pListaAnios','pAnioActual'],
	data() {
        return {
			Mes:"",
			IdConfigS:"",
            isOverlay:false,
            isVisible:false,
            masks: {
				input: "DD/MM/YYYY"
			},
            rangeDate:{
                start:null,
                end:null
            },
            ListaClientes:[],
            ListaSucursales:[],
			ListaDashboard:[],
            IdCliente:null,
            IdClienteS:null,
			Anio:new Date().getFullYear()
        }
    },
	methods: {
		mostrarfiltro(){
            this.isVisible=true;
        },
        ocultarfiltro(){
            this.isVisible=false;
        },
		async GetDashboard(){
            this.isOverlay=true;
            return new Promise((resolve,reject)=>{
				this.$http.get('dashboardventas/vendedores',{
            	    params:{
            	        // Fecha_I:this.rangeDate.start,
            	        // Fecha_F:this.rangeDate.end,
            	        // IdCliente:this.IdCliente,
            	        // IdClienteS:this.IdClienteS,
            	        // IdTrabajador:this.IdTrabajador
						Anio:this.Anio,
						IdConfigS:this.IdConfigS,
						Mes:this.Mes
            	    }
            	}).then((res)=>{
            	    this.ListaDashboard=res.data.data;
					this.isOverlay=false;
					resolve(res.data);
            	}).catch((e) => {
					this.isOverlay = false;
					reject(e.response.data)
				});;
			});
        },
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
	},
	created() {
		if(this.pListaAnios !== undefined){
			this.ListaAnios = this.pListaAnios;
		}

		if(this.pAnioActual !== undefined) {
			this.Anio = this.pAnioActual
		}

		// this.bus.$off("Ocultar7");
		// this.bus.$on("Ocultar7", data => {
		// 	this.Ocultar(data);
		// });
	},
	computed: {
		anios(){
			if(this.pListaAnios !== undefined){
				this.ListaAnios = this.pListaAnios;
			}
		},

		anioActual(){
			if(this.pAnioActual !== undefined) {
				this.Anio = this.pAnioActual

			}
		}
	},
}
</script>

<style>

</style>
